import React from 'react';
import {SignUpContainer} from "./sign_up_styles";
import {LightButton} from "../common_style/button";
import {LightTextInput} from "../common_style/text_input";
import {LinkLight} from "../common_style/link";
import {Span} from "../common_style/text";
import {Colors, FontStyles, Routes} from "../constants";
// assets
import logo from '../../assets/icons/logo.png';
import eu_flag from '../../assets/icons/eu_flag.png';
import {Localization} from "localizations/languages";

function SignUpAccCreatedView(props) {
    return <SignUpContainer onSubmit={(e) => {
        e.preventDefault();
        props.history.replace(Routes.signin);
    }}>
        <img style={{width: '274px', marginTop: '47px', marginBottom: '155px'}} src={logo}/>
        <Span textStyle={FontStyles.titleLight}>{Localization.current.translation36}</Span>
        <div style={{height: '20px'}}/>
        <Span style={{padding: '10px', textAlign: 'center'}} textStyle={FontStyles.bodyLight}>{Localization.current.translation37}</Span>
        <div style={{height: '20px'}}/>
        <LightButton>
            {Localization.current.translation32}
        </LightButton>
        <div style={{height: '300px'}}/>
        <div style={{display: 'flex', width: '320px', alignItems: 'center', marginBottom: '48px'}}>
            <img style={{height: '65px', marginRight: '20px'}} src={eu_flag}/>
            <Span textStyle={FontStyles.smallPrintLight}>This project is part of a project that has received funding from the European Union’s Horizon 2020 research and innovation programme under grant agreement Nº822664</Span>
        </div>
    </SignUpContainer>
}

export default SignUpAccCreatedView;